import styled from 'styled-components';
import {
  COLOR_BLACK,
  COLOR_SPOTIFY_GREEN,
} from 'client/components/MarketingPagesShared/styles';

export const LoginSignupContainer = styled.div`
  padding: 70px 20%;
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  color: ${COLOR_BLACK};
  text-align: center;
  > svg {
    max-height: 90px;
    width: 100%;
    margin-bottom: 40px;
  }
  input:active,
  input:focus,
  select: active,
  select: focus {
    border-color: ${COLOR_SPOTIFY_GREEN};
  }
  button {
    color: ${COLOR_BLACK};
    &[type='submit'],
    &[type='submit']:focus,
    &[type='submit']:active:hover:focus {
      background: ${COLOR_SPOTIFY_GREEN};
      border-color: ${COLOR_SPOTIFY_GREEN};
    }
  }
  form {
    margin: 0 auto;
    max-width: 372px;
    width: 100%;
  }
  a {
    color: ${COLOR_BLACK};
    font-weight: bold;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
  div[class*='styles__successButton'] {
    svg > circle {
      fill: ${COLOR_SPOTIFY_GREEN};
    }
  }
`;

export const LoginSignupHeading = styled.h2`
  font-size: 30px;
  line-height: 40px;
  letter-spacing: -0.008em;
  margin: 0 0 8px;
`;

export const LoginSignupSubheading = styled.p`
  font-size: 22px;
  line-height: 26px;
  letter-spacing: -0.008em;
  margin: 0 0 40px;
  max-width: 372px;
`;

export const LoginSignUpOptionsContainer = styled.div`
  margin-top: 25px;
  p:first-child {
    margin-bottom: 10px;
  }
`;

export const LoginSignUpOption = styled.p`
  button {
    font-weight: bold;
    color: ${COLOR_BLACK};
    padding: 0;
  }

  a,
  a:focus {
    font-weight: bold;
    color: ${COLOR_BLACK};
  }
`;

export const LoginSignUpTerms = styled.div`
  margin-top: 50px;
  a,
  a:focus {
    font-weight: bold;
    color: ${COLOR_BLACK};
  }
`;
